__turbopack_context__.v({
  "arrow": "deviceDetails-module-scss-module__s6r6vW__arrow",
  "border-tab": "deviceDetails-module-scss-module__s6r6vW__border-tab",
  "border-title": "deviceDetails-module-scss-module__s6r6vW__border-title",
  "brief": "deviceDetails-module-scss-module__s6r6vW__brief",
  "button": "deviceDetails-module-scss-module__s6r6vW__button",
  "button-selected": "deviceDetails-module-scss-module__s6r6vW__button-selected",
  "camera": "deviceDetails-module-scss-module__s6r6vW__camera",
  "container": "deviceDetails-module-scss-module__s6r6vW__container",
  "detail-container": "deviceDetails-module-scss-module__s6r6vW__detail-container",
  "edit": "deviceDetails-module-scss-module__s6r6vW__edit",
  "edit-controls": "deviceDetails-module-scss-module__s6r6vW__edit-controls",
  "edit-icon": "deviceDetails-module-scss-module__s6r6vW__edit-icon",
  "edit-loader": "deviceDetails-module-scss-module__s6r6vW__edit-loader",
  "edit-text": "deviceDetails-module-scss-module__s6r6vW__edit-text",
  "fade-in-ux308br": "deviceDetails-module-scss-module__s6r6vW__fade-in-ux308br",
  "icon-hidden": "deviceDetails-module-scss-module__s6r6vW__icon-hidden",
  "icons": "deviceDetails-module-scss-module__s6r6vW__icons",
  "name": "deviceDetails-module-scss-module__s6r6vW__name",
  "name-icon": "deviceDetails-module-scss-module__s6r6vW__name-icon",
  "name-text": "deviceDetails-module-scss-module__s6r6vW__name-text",
  "name-text-placeholder": "deviceDetails-module-scss-module__s6r6vW__name-text-placeholder",
  "skeleton-details": "deviceDetails-module-scss-module__s6r6vW__skeleton-details",
  "skeleton-sublist": "deviceDetails-module-scss-module__s6r6vW__skeleton-sublist",
  "sublist": "deviceDetails-module-scss-module__s6r6vW__sublist",
  "sublist-container": "deviceDetails-module-scss-module__s6r6vW__sublist-container",
  "sublist-empty": "deviceDetails-module-scss-module__s6r6vW__sublist-empty",
  "sublist-header": "deviceDetails-module-scss-module__s6r6vW__sublist-header",
  "sublist-row": "deviceDetails-module-scss-module__s6r6vW__sublist-row",
  "sublist-row--selected": "deviceDetails-module-scss-module__s6r6vW__sublist-row--selected",
  "sublist-row-strikethrough": "deviceDetails-module-scss-module__s6r6vW__sublist-row-strikethrough",
  "tabs": "deviceDetails-module-scss-module__s6r6vW__tabs",
  "td-icons": "deviceDetails-module-scss-module__s6r6vW__td-icons",
  "title": "deviceDetails-module-scss-module__s6r6vW__title",
  "title-icon": "deviceDetails-module-scss-module__s6r6vW__title-icon",
});
